import gsap from 'gsap';
import bindAll from 'lodash/bindAll';
import classes from 'dom-helpers/class';
import { stringToDOM, lerp } from '../base/utils';

class Cursor {
    constructor() {
        bindAll(this, ['render']);

        this.mouse = {
            x: 0,
            y: 0,
        };

        this.interMouse = this.mouse;
        this.isMoved = false;
        this.createCursor();
        this.bindEvents();
        this.render();
    }

    createCursor() {
        const template = `
            <svg viewBox="0 0 180 90">
              <path d="M170.9 3.4L88.8 88.9 6.6 3.4"/>
            </svg>
            <svg class="second-arrow" viewBox="0 0 180 180">
              <path d="M172.1 4.5L90 90 7.8 4.5"/>
              <path d="M7.9 175.5L90 90l82.2 85.5"/>
            </svg>`;

        this.cursor = stringToDOM(`<span class="cursor">${template}</span>`);
        this.cursor.style.opacity = 0;
        document.body.appendChild(this.cursor);
    }

    render() {
        this.setPos();
        window.requestAnimationFrame(this.render);
    }

    setPos() {
        if (this.mouse.x !== 0 && this.mouse.y !== 0) {
            gsap.to(this.cursor, 0.5, {
                opacity: 1,
                delay: 2,
            });
        }

        this.interMouse.x = lerp(this.mouse.x, this.interMouse.x, 0.6);
        this.interMouse.y = lerp(this.mouse.y, this.interMouse.y, 0.6);

        this.cursor.style.top = `${this.interMouse.y}px`;
        this.cursor.style.left = `${this.interMouse.x}px`;
    }

    bindEvents() {
        const cursors = Array.from(document.querySelectorAll('[data-cursor]'));

        window.addEventListener('mousemove', (event) => {
            this.mouse = {
                x: event.clientX,
                y: event.clientY,
            };
        }, false);

        cursors.forEach((el) => {
            const attr = el.getAttribute('data-cursor');
            const connect = el.getAttribute('data-connect');
            const connects = document.querySelectorAll(`[data-connect="${connect}"]`);


            el.addEventListener('mouseenter', () => {
                classes.addClass(this.cursor, `cursor--${attr}`);
                connects.forEach((c) => {
                    classes.addClass(c, 'is-hover');
                });
            }, false);

            el.addEventListener('mouseleave', () => {
                classes.removeClass(this.cursor, `cursor--${attr}`);
                connects.forEach((c) => {
                    classes.removeClass(c, 'is-hover');
                });
            }, false);
        });
    }
}

export default Cursor;



/** WEBPACK FOOTER **
 ** ./components/cursor.js
 **/